import React, { use, version } from 'react';
import { useState, useEffect } from "react";
import { Link } from 'react-router';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle} from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Select } from '../components/ui/Select';
import { Textarea } from '../components/ui/textarea';
import { cierres, agentes, empleados } from '../utils/mockData';
import { CierreAgenteResponse } from '../types/cierreAgente';
import { EmpleadoService } from "../services/empleadoService";
import { AgenteService } from '../services/agenteService';
import { useToast } from "../components/ui/toast-provider";
import { CierreAgenteService } from "../services/cierreAgenteService";
import { DepositoBancoService } from "../services/depositoBancoService";
import DetalleCierres from '../modals/DetalleCierres';
import Confirmar from '../modals/Confirmar';
import { BancoService } from '../services/bancoService';
import { BancoResponse } from '../types/puesto';
import { DepositoBancoResponse } from '../types/depositoBanco' 
import { useNavigate } from "react-router";
import LogoBlanco from '../components/img/LogoBlanco.png';

import {
  User,
  Store,
  Calculator,
  Calendar,
  CheckCircle,
  AlertCircle,
  TrendingDown,
  TrendingUp,
  Banknote,
  Coins,
  Save,
  FileDown,
  Paperclip,
  Loader,
  Eye,
  BadgeAlert,
  Landmark,
  CircleMinus
} from 'lucide-react';

// Servicios
import { CambiosCierreService } from "../services/cambiosCierreService";
// Tipos de Response
import { CambiosCierreResponse} from "../types/cambiosCierre";

interface DenominacionBilletes {
  totalBilletes200: number;
  totalBilletes100: number;
  totalBilletes50: number;
  totalBilletes20: number;
  totalBilletes10: number;
  totalBilletes5: number;
  totalBilletes1: number;
}

interface DenominacionMonedas {
  totalMonedas1: number;
  totalMonedas050: number;
  totalMonedas025: number;
  totalMonedas010: number;
  totalMonedas005: number;
  totalMonedas001: number;
}

export function CierreAnterior() {
  const { user } = useAuth();
  const { addToast } = useToast();
  const [error, setError] = useState("");
  const [errorBoleta, setErrorBoleta] = useState("");
  const [efectivoDepositar, setEfectivoDepositar] = useState("");
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);
  const [resumenOperador, setResumenOperador] = useState<any>(null);
  const [isLoading2, setIsLoading2] = useState(true);
  const [error2, setError2] = useState<string | null>(null);
  const [id, setId] = useState("");
  const [version, setVersion] = useState("");
  const [sobregirado, setSobregirado] = useState(false);
  const [bancos, setBancos] = useState<BancoResponse[]>([]);
  const [depositoBancoList, setDepositoBancosList] = useState<DepositoBancoResponse[]>([]);
  const [comentario, setComentario] = useState("");
  const [observacion, setObservacion] = useState("");
  const [fechaCrear, setFechaCrear] = useState("");
  const [fechaCierreDesactivar, setFechaCierreDesactivar] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [saldoFocused, setSaldoFocused] = useState(false);
  const [boletaFocused, setBoletaFocused] = useState(false);

  const [cambiosCierres, setcambiosCierres] = useState<CambiosCierreResponse[]>([]);

  const navigate = useNavigate();

  // INFORMACIÓN DEL AGENTE
  const [infoAGente, setInfoAgente] = useState({ idAgente: 0, usuario: '', agente: '', nombreNegocio: '', propietario: '', ubicacion: '', monto: 0 });

  // DEPÓSITO PARA CREAR
  const [depositoBanco, setDepositoBanco] = useState({ cantidad: '', idBanco: '', noBoleta: '', fechaBoleta: '' })

  const fechaNoSeleccionada = !fechaCrear || fechaCrear.length === 0;
  //Obtener fechas
  useEffect(() => {
    //Info del Agente
    const fetchAgente = async () => {
      if (!user?.idEmpleado) return;
      try {
        const response = await AgenteService.getByEmpleado(Number(user.idEmpleado));
        const agente = response.data;

        //console.log(agente)

        setInfoAgente({
          idAgente: agente.idAgente,
          usuario: agente.usuario,
          agente: agente.agente,
          nombreNegocio: agente.nombreNegocio,
          propietario: agente.propietario,
          ubicacion: agente.ubicacion,
          monto: Number(agente.monto)
        });

        cargarFechas(agente.idAgente)
        //fetchCierreAgente(agente.idAgente);
      } catch (err) {
        console.error("Error al cargar empleado:", err);
      }
    };

    //Bancos
    const cargarBancos = async () => {
        try {
          const res = await BancoService.getAll(true);
          setBancos(res.data);
        } catch (err) {
          setError("Error al cargar bancos");
        }
      };

    fetchAgente();
    cargarBancos();

  }, [user?.idEmpleado]);

useEffect(() => {

    const cargarCierre = async () => {
        try {
          //console.log("VOY A MANDAR: ", fechaCrear)
          fetchCierreAgente(infoAGente.idAgente)
        } catch (err) {
          setError("Error al cargar cierre");
          reiniciar();
        }
      };
    cargarCierre();

}, [fechaCrear]);

  // CARGAR FECHAS
  const cargarFechas = async (id: number) => {
    try {
      const response = await CambiosCierreService.getByAgente(id);
      const activos = response.data.filter((item: any) => item.activo === true);
        setcambiosCierres(activos);
    } catch (err) {
      setError("Error al cargar boletas");
    }
  };

  // CARGAR BOLETAS CUANDO NO HA GUARDADO NINGÚN CIERRE, PASO IDAGENTE
  const cargarBoletasSinCierre = async (id: number) => {
    try {
      const res = await DepositoBancoService.obtener(id, fechaCrear);
      //console.log(res.data)
      setDepositoBancosList(res.data);
      //console.log("RESPUESTA: ", depositoBancoList)
    } catch (err) {
      setError("Error al cargar boletas");
    }
  };

  // CARGAR BOLETAS CUANDO YA HAY UN CIERRE, PASO IDCIERREAGENTE
  const cargarBoletasConCierre = async (id: number) => {
    try {
      const res = await DepositoBancoService.getByCierre(id);
      //console.log(res.data)

      const dataTransformada: DepositoBancoResponse[] = res.data.map((item: any) => ({
        idDepositoBanco: item.idDepositoBanco,
        cantidad: Number(item.cantidad),
        noBoleta: item.noBoleta,
        fechaBoleta: item.fechaBoleta,
        banco: item.banco,
        idAgente: infoAGente.idAgente,
        activo: item.activo
      }));

      setDepositoBancosList(dataTransformada);
      //setDepositoBancosList(res.data);
      //console.log("RESPUESTA: ", depositoBancoList)
    } catch (err) {
      setError("Error al cargar boletas");
    }
  };

  // CARGAR CIERRE DEL DÍA SI ES QUE HAY, PASO IDAGENTE
  const fetchCierreAgente = async (id: number) => {

    setSobregirado(false);

    if (!id || id === 0) return;

    try {
      const response = await CierreAgenteService.getCierre(id, fechaCrear);
      const cierre = response.data;
      //console.log("No se si vino: ", cierre)

      if (!cierre) return;

      setBilletes({
        totalBilletes200: Number(cierre.totalBilletes200) || 0,
        totalBilletes100: Number(cierre.totalBilletes100) || 0,
        totalBilletes50: Number(cierre.totalBilletes50) || 0,
        totalBilletes20: Number(cierre.totalBilletes20) || 0,
        totalBilletes10: Number(cierre.totalBilletes10) || 0,
        totalBilletes5: Number(cierre.totalBilletes5) || 0,
        totalBilletes1: Number(cierre.totalBilletes1) || 0,
      });

      setMonedas({
        totalMonedas1: Number(cierre.totalMonedas1) || 0,
        totalMonedas050: Number(cierre.totalMonedas050) || 0,
        totalMonedas025: Number(cierre.totalMonedas025) || 0,
        totalMonedas010: Number(cierre.totalMonedas010) || 0,
        totalMonedas005: Number(cierre.totalMonedas005) || 0,
        totalMonedas001: Number(cierre.totalMonedas001) || 0,
      });

      setSaldoSistema(cierre.saldoSistema.toString());

      setComentario(cierre.comentario)

      //console.log(cierre.observacion)
      setObservacion(cierre.observacion)

      setId((cierre.idCierreAgente ?? 0).toString());
      setVersion((cierre.version).toString());

      cargarBoletasConCierre(cierre.idCierreAgente)

    } catch (err) {
      console.error("Error al cargar cierre:", err);
      reiniciar();
      cargarBoletasSinCierre(id);
    }
  };

  // Cierre de hoy
  const hoy = new Date().toISOString().split('T')[0];

  const getEstadoIcon = (estado: string) => {
    switch (estado) {
      case 'Cuadrado':
        return <CheckCircle className="w-5 h-5 text-accent" />;
      case 'Faltante':
        return <TrendingDown className="w-5 h-5 text-destructive" />;
      case 'Sobrante':
        return <TrendingUp className="w-5 h-5 text-[#dea753]" />;
      default:
        return <AlertCircle className="w-5 h-5 text-muted-foreground" />;
    }
  };

  const getEstadoColor = (estado: string) => {
    switch (estado) {
      case 'Cuadrado':
        return 'text-accent';
      case 'Faltante':
        return 'text-destructive';
      case 'Sobrante':
        return 'text-[#dea753]';
      default:
        return 'text-muted-foreground';
    }
  };

  const irAlDashboard = () => {
    navigate("/dashboard");
  };

  //Billetes y Monedas
  const [totalBilletes, setTotalBilletes] = useState(0);
  const [totalMonedas, setTotalMonedas] = useState(0);
  const [totalEfectivo, setTotalEfectivo] = useState(0);

  const [billetes, setBilletes] = useState<DenominacionBilletes>({
    totalBilletes200: 0,
    totalBilletes100: 0,
    totalBilletes50: 0,
    totalBilletes20: 0,
    totalBilletes10: 0,
    totalBilletes5: 0,
    totalBilletes1: 0,
  });

  const [monedas, setMonedas] = useState<DenominacionMonedas>({
    totalMonedas1: 0,
    totalMonedas050: 0,
    totalMonedas025: 0,
    totalMonedas010: 0,
    totalMonedas005: 0,
    totalMonedas001: 0,
  });

  const handleBilleteChange = (denominacion: keyof DenominacionBilletes, valor: string) => {
    const num = parseInt(valor) || 0;
    setBilletes({ ...billetes, [denominacion]: num });
  };

  const handleMonedaChange = (denominacion: keyof DenominacionMonedas, valor: string) => {
    const num = parseInt(valor) || 0;
    setMonedas({ ...monedas, [denominacion]: num });
  };

  const handleSistema = (valor: string) => {
    const numeric = valor.replace(/\D/g, "");
    const number = (parseInt(numeric || "0") / 100).toFixed(2);
    setSaldoSistema(number);
  };

  const reiniciar = () => {
    setBilletes({
      totalBilletes200: 0,
      totalBilletes100: 0,
      totalBilletes50: 0,
      totalBilletes20: 0,
      totalBilletes10: 0,
      totalBilletes5: 0,
      totalBilletes1: 0,
    });

    setMonedas({
      totalMonedas1: 0,
      totalMonedas050: 0,
      totalMonedas025: 0,
      totalMonedas010: 0,
      totalMonedas005: 0,
      totalMonedas001: 0,
    })

    setError('');

    setSobregirado(false);

    setSaldoSistema("0.00");

    setTotalEfectivo(0);
  }

    const billetesDenominaciones = [
    { key: 'totalBilletes200' as keyof DenominacionBilletes, valor: 200, label: 'Q200.00' },
    { key: 'totalBilletes100' as keyof DenominacionBilletes, valor: 100, label: 'Q100.00' },
    { key: 'totalBilletes50' as keyof DenominacionBilletes, valor: 50, label: 'Q50.00' },
    { key: 'totalBilletes20' as keyof DenominacionBilletes, valor: 20, label: 'Q20.00' },
    { key: 'totalBilletes10' as keyof DenominacionBilletes, valor: 10, label: 'Q10.00' },
    { key: 'totalBilletes5' as keyof DenominacionBilletes, valor: 5, label: 'Q5.00' },
    { key: 'totalBilletes1' as keyof DenominacionBilletes, valor: 1, label: 'Q1.00' },
  ];

  const monedasDenominaciones = [
    { key: 'totalMonedas1' as keyof DenominacionMonedas, valor: 1.0, label: 'Q1.00' },
    { key: 'totalMonedas050' as keyof DenominacionMonedas, valor: 0.5, label: 'Q0.50' },
    { key: 'totalMonedas025' as keyof DenominacionMonedas, valor: 0.25, label: 'Q0.25' },
    { key: 'totalMonedas010' as keyof DenominacionMonedas, valor: 0.1, label: 'Q0.10' },
    { key: 'totalMonedas005' as keyof DenominacionMonedas, valor: 0.05, label: 'Q0.05' },
    { key: 'totalMonedas001' as keyof DenominacionMonedas, valor: 0.01, label: 'Q0.01' },
  ];

  const [saldoMutilado, setSaldoMutilado] = useState(100.00);
  const [saldoSistema, setSaldoSistema] = useState("0.00");
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [diferencia, setDiferencia] = useState(0);
  const [estado, setEstado] = useState<'Cuadrado' | 'Faltante' | 'Sobrante' | 'Pendiente'>(
    'Pendiente'
  );

  //CALCULAR CIERRE Y SUS DATOS Y ESAS COSAS
  useEffect(() => {
    //console.log(fechaCrear, " Fecha en la que quiero crear");
    setEfectivoDepositar("");
    setSobregirado(false);
    // Calcular total de billetes
    const sumaBilletes =
      billetes.totalBilletes200 * 200 +
      billetes.totalBilletes100 * 100 +
      billetes.totalBilletes50 * 50 +
      billetes.totalBilletes20 * 20 +
      billetes.totalBilletes10 * 10 +
      billetes.totalBilletes5 * 5 +
      billetes.totalBilletes1 * 1;
    setTotalBilletes(sumaBilletes);

    // Calcular total de monedas
    const sumaMonedas =
      monedas.totalMonedas1 * 1 +
      monedas.totalMonedas050 * 0.5 +
      monedas.totalMonedas025 * 0.25 +
      monedas.totalMonedas010 * 0.1 +
      monedas.totalMonedas005 * 0.05 +
      monedas.totalMonedas001 * 0.01;
    setTotalMonedas(sumaMonedas);

    // Calcular total de boletas

    let totalDepositos = 0

    depositoBancoList.map((deposito) => (
      totalDepositos += Number(deposito.cantidad)
    ))

    //console.log("depositos: ", totalDepositos, " billetes: ", sumaBilletes, " monedas: ", monedas)

    // Calcular total general
    const total = sumaBilletes + sumaMonedas + totalDepositos;
    setTotalGeneral(total);

    setTotalEfectivo(sumaBilletes + sumaMonedas);

    // Calcular diferencia y estado
    if (saldoSistema !== null) {
      const diff = total - parseFloat(saldoSistema);
      setDiferencia(diff);
      //console.log("DIFERENCIA: ",diff)

      if (Math.abs(diff) < 0.01) {
        setEstado('Cuadrado');
      } else if (diff < 0) {
        setEstado('Faltante');
      } else {
        setEstado('Sobrante');
      }

      if (total > infoAGente.monto) {
        setSobregirado(true);

        //console.log("1. ", total, " > ", infoAGente.monto)

        const valor = total - infoAGente.monto - totalDepositos;

        if (valor > 0){
          setEfectivoDepositar("EL TOTAL EXCEDE EL MONTO PERMITIDO. DEPOSITE Q" + Number(valor).toLocaleString('es-GT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + " AL BANCO.");
        }
      }

      //console.log("ESTOY AQUÍ: ", infoAGente.monto)
      if (parseFloat(saldoSistema) > infoAGente.monto){
        setSobregirado(true);

        //console.log("2. ", saldoSistema, " > ", infoAGente.monto)

        const valor = parseFloat(saldoSistema) - infoAGente.monto - totalDepositos;

        if (valor > 0){
          setEfectivoDepositar("EL TOTAL EXCEDE EL MONTO PERMITIDO. DEPOSITE Q" + Number(valor).toLocaleString('es-GT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + " AL BANCO.");
        }
      }

    } else {
      setDiferencia(0);
      setEstado('Pendiente');
    }

  }, [billetes, monedas, saldoSistema, depositoBancoList]);

  const handleSubmit = async () => {
    if(fechaCrear.length <= 0){
      setError("No hay una fecha seleccionada para el cierre")
      return;
    }

    if(parseFloat(saldoSistema) <= 0){
      setError("El saldo del sistema debe ser mayor a Q0.00");
      setIsSubmitting(false);
      return;
    }

    if (isSubmitting) return; // Prevenir múltiples ejecuciones
  
    setIsSubmitting(true);
      try {
        const id = await CierreAgenteService.crearCierre2({
            ...billetes,
            ...monedas,
            saldoSistema: parseFloat(saldoSistema),
            idAgente: infoAGente.idAgente,
            idEmpleado: user?.idEmpleado || 0,
            comentario: comentario,
            fecha: fechaCrear
        });

        addToast("Cierre guardado exitosamente");

        cambiarEstadoFecha(fechaCierreDesactivar);

        //console.log("Creado: ", id.data.idCierreAgente)

        depositoBancoList.map((deposito) => (
          handleRelacion(id.data.idCierreAgente, Number(deposito.idDepositoBanco), true)
        ))

        setError2("");
        setError("");

        irAlDashboard();

      } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al guardar cierre";

            setError(message);
      } finally {
    setIsSubmitting(false);
  }
  }

    const cambiarEstadoFecha = async (id: number) => {
        try {
            await CambiosCierreService.desactivar(id);
        } catch (err) {
        setError("Error al cambiar estado del empleado");
        }
    };

  // CREO LA RELACIÓN DE LA BOLETA
  const handleRelacion = async (idCierre: number, idBoleta: number, pertenece: boolean) => {
    try {
      //console.log("ENTRÓ AQUÍ intentando crear ", idCierre, " - ", idBoleta, " - ", pertenece)
        await CierreAgenteService.crearRelacion({
              idCierreAgente: idCierre, 
              idDepositoBanco: idBoleta,
              activo: pertenece
            })

            //console.log("LO CREÓ?")

      } catch (err:any) {
        //console.log("PERDIDA")
              const message =
                err?.response?.data?.message ||
                "Error inesperado al guardar cierre";

            setErrorBoleta(message);
      }
  }

  // CREO LA BOLETA
  const handleBoleta = async () => {
      try {
        const d = new Date();

        //console.log("ANTES:", id, " es ", id.length, " y resulta ", id.length!=0)

        const res =
        await DepositoBancoService.crear({
          ...depositoBanco,
          cantidad: Number(depositoBanco.cantidad),
          idBanco: Number(depositoBanco.idBanco),
          fecha: fechaCrear,
          fechaBoleta: depositoBanco.fechaBoleta,
          idAgente: infoAGente.idAgente
        });

        //console.log("DESPUÉS:", id, " es ", id.length, " y resulta ", id.length!=0)

        if(id.length!=0){   
          await handleRelacion(Number(id), Number(res.data.idDepositoBanco.idDepositoBanco), false)
          await cargarBoletasConCierre(Number(id));
        } else {
          await cargarBoletasSinCierre(infoAGente.idAgente);
        }

        //console.log("CREADO BOLETA: ", res.data.idDepositoBanco.idDepositoBanco)
        addToast("Boleta guardada exitosamente");
        setDepositoBanco({ ...depositoBanco, cantidad: '', noBoleta: '', fechaBoleta: '' });
        //fetchCierreAgente(infoAGente.idAgente)
        setErrorBoleta("");

      } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al guardar cierre";

            setErrorBoleta(message);
      }
  }

  // DESACTIVAR BOLETA
  const cambiarEstado = async (idBoleta: number) => {
    setIsLoading2(true);
    try {
        await DepositoBancoService.desactivar(idBoleta);
        addToast("Boleta eliminada exitosamente");

        await cargarBoletasConCierre(Number(id));
    } catch (err) {
      setError("Error al eliminar boleta");
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-6 md:grid-cols-6 gap-4 p-6 text-white bg-primary border border-primary rounded-t-lg items-center">
        {/* Logo */}
        <div className="col-span-2 md:col-span-1 flex justify-center md:justify-start">
            <img 
            src={LogoBlanco} 
            alt="Logo AGEMI" 
            className="w-20 md:w-40 h-auto object-contain"
            />
        </div>
        <div className="col-span-4 md:col-span-5 flex flex-col text-sm md:text-base">
          <h1 className="text-3xl font-bold">Cuadrar Cierre Anterior</h1>
        <p className="text-base text-white mt-1 md:mt-2">
          Gestión de cierres para fechas anteriores
        </p>
        </div>
      </div>
      {/* Cierre de Hoy */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        {/* Formulario de Billetes y Monedas */}
        <Card className="md:row-span-2">
          <CardHeader className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5 text-accent" />
              <CardTitle>Cierre del: </CardTitle>
            </div>
            <div>
                <Select
                className='bg-white text-primary'
                  value={fechaCierreDesactivar.toString()}
                  onChange={(e) => {
                    const idSeleccionado = Number(e.target.value);

                    const seleccionado = cambiosCierres.find(
                      (c) => c.idCambiosCierre === idSeleccionado
                    );

                    if (seleccionado) {
                      setFechaCierreDesactivar(idSeleccionado);
                      setFechaCrear(seleccionado.fecha.split('T')[0]);
                    }
                  }}
                  options={cambiosCierres
                    .filter((item) => item.activo)
                    .map((item) => ({
                      value: item.idCambiosCierre!.toString(),
                      label: new Date(item.fecha).toLocaleDateString('es-GT', {
                        timeZone: 'UTC',
                      }),
                    }))
                  }
                />
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-end'>
                <div className='grid grid-cols-1 gap-4 items-end'>
                  <div className="flex items-center gap-2">
                    <Banknote className="w-5 h-5 text-primary" />
                    <CardTitle>Billetes</CardTitle>
                  </div>
                  {billetesDenominaciones.map((denom) => (
                    <div key={denom.key} className='grid grid-cols-2 items-end'>
                      <Input
                        className='bg-white rounded-r-none border-primary/10'
                        label={denom.label}
                        type="number"
                        min="0"
                        value={billetes[denom.key]}
                        onChange={(e) => handleBilleteChange(denom.key, e.target.value)}
                        placeholder="0"
                        disabled={fechaNoSeleccionada}
                      />
                      <div>
                        <div className="px-4 py-2 bg-primary/10 border border-primary/0 rounded-r-lg text-center font-medium text-primary">
                          Q{(billetes[denom.key] * denom.valor).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="pt-4 border-t-1 border-primary">
                    <div className="grid grid-cols-2 gap-4 items-end">
                      <div className="py-2 text-start font-medium">
                        Total:
                      </div>
                      <div>
                        <div className="px-4 py-2 rounded-lg text-center font-medium text-primary">
                          Q{Number(totalBilletes).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) || "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='grid grid-cols-1 gap-4 items-end'>
                  <div className="flex items-center gap-2">
                    <Coins className="w-5 h-5 text-primary" />
                    <CardTitle>Monedas</CardTitle>
                  </div>
                  {Array.from({ length: 7 }).map((_, index) => {
                    const denom = monedasDenominaciones[index];

                    return denom ? (
                      <div key={denom.key} className='grid grid-cols-2 items-end'>
                        <Input
                          className='bg-white rounded-r-none border-primary/10'
                          label={denom.label}
                          type="number"
                          min="0"
                          value={monedas[denom.key]}
                          onChange={(e) => handleMonedaChange(denom.key, e.target.value)}
                          placeholder="0"
                          disabled={fechaNoSeleccionada}
                        />
                        <div>
                          <div className="px-4 py-2 bg-primary/10 border border-primary/0 rounded-r-lg text-center font-medium text-primary">
                            Q{(monedas[denom.key] * denom.valor).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </div>
                        </div>
                      </div>
                      ) : (
                        <div
                          key={`empty-${index}`}
                          className="grid grid-cols-2 gap-4 items-end invisible"
                        >
                          <Input label="placeholder" />
                          <div>
                            <div className="px-4 py-2 rounded-lg">Q0.00</div>
                          </div>
                        </div>
                      );
                  })}
                  <div className="pt-4 border-t-1 border-primary">
                    <div className="grid grid-cols-2 gap-4 items-end">
                      <div className="py-2 text-start font-medium">
                        Total:
                      </div>
                      <div>
                        <div className="px-4 py-2 rounded-lg text-center font-medium text-primary">
                          Q{Number(totalMonedas).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) || "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Boletas */}
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
                <Landmark className="w-5 h-5 text-accent" />
                <CardTitle>Boleta Bancaria</CardTitle>
            </div>
          </CardHeader>

          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
              <Input
                label="Monto:"
                type="text"
                inputMode="decimal"
                value={
                  boletaFocused
                    ? depositoBanco.cantidad
                    : depositoBanco.cantidad
                      ? `Q${Number(depositoBanco.cantidad).toLocaleString('es-GT', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}`
                      : ''
                }
                onFocus={() => setBoletaFocused(true)}
                onBlur={() => setBoletaFocused(false)}
                onChange={(e) => setDepositoBanco({ ...depositoBanco, cantidad: e.target.value })}
              />

              <Input
                label="Fecha Boleta:"
                type="date"
                max={hoy}
                value={depositoBanco.fechaBoleta}
                onChange={(e) =>
                  setDepositoBanco({ ...depositoBanco, fechaBoleta: e.target.value })
                }
                disabled={fechaNoSeleccionada}
              />

              <Input
                label="No. Boleta:"
                type="text"
                maxLength={13}
                value={depositoBanco.noBoleta}
                onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ''); // solo números
                    setDepositoBanco({ ...depositoBanco, noBoleta: value })
                }}
                placeholder="0000000000000"
                required
                disabled={fechaNoSeleccionada}
              />

              <div className="md:col-span-2">
                <Select
                  label="Banco"
                  value={depositoBanco.idBanco}
                  onChange={(e) =>
                    setDepositoBanco({ ...depositoBanco, idBanco: e.target.value })
                  }
                  options={bancos.map((r) => ({
                    value: r.idBanco!.toString(),
                    label: r.banco,
                  }))}
                  disabled={fechaNoSeleccionada}
                />
              </div>

              <Button variant="primary" onClick={handleBoleta} disabled={fechaNoSeleccionada}>
                Agregar Boleta
              </Button>

              <div className = "pt-4 flex gap-4 justify-center items-center md:col-span-3">
                {errorBoleta && (
                    <span className="text-destructive text-center text-sm">{errorBoleta}</span>
                )}
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Resultado */}
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Calculator className="w-5 h-5 text-accent" />
              <CardTitle>Resultado del Cierre</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
                <div className="grid grid-cols-3 gap-4 items-end">
                  <div className="py-2 text-start font-medium col-span-2">
                    Saldo Según Sistema:
                  </div>
                  <div>
                    <Input
                      className="bg-white text-end"
                      type="text"
                      inputMode="numeric"
                      value={
                        saldoFocused
                          ? saldoSistema
                          : `Q${Number(saldoSistema).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}`
                      }
                      onFocus={() => setSaldoFocused(true)}
                      onBlur={() => setSaldoFocused(false)}
                      onChange={(e) => handleSistema(e.target.value)}
                      disabled={fechaNoSeleccionada}
                    />
                  </div>
                  <div className="py-2 text-start font-medium col-span-2">
                    Efectivo Físico:
                  </div>
                  <div>
                    <div className="px-4 py-2 pr-7 bg-accent/10 border border-accent/0 rounded-lg text-end font-medium text-accent">
                      Q{Number(totalEfectivo).toLocaleString('es-GT', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </div>
                  </div>
                  <div className="py-2 text-start font-medium col-span-2">
                    Boleta de Banco:
                  </div>
                  <div>
                  </div>
                  <div className='col-span-2 md:pr-10'>
                  {
                    depositoBancoList.length === 0 ? (
                      <div className="py-2 text-start align-bottom">
                        <p className="text-sm text-muted-foreground">No hay boletas</p>
                      </div>
                    ) : (
                      depositoBancoList.map((deposito) => (
                        <div key={deposito.idDepositoBanco} className="py-2 flex items-center justify-between">
                          <div className="flex flex-col text-sm text-muted-foreground">
                            <div className="flex gap-6">
                              <span>No: {deposito.noBoleta}</span>
                              <span>Fecha: {new Date(deposito.fechaBoleta).toLocaleDateString('es-GT')}</span>
                            </div>

                            <span>Banco: {deposito.banco}</span>
                          </div>

                          <Button
                            size="sm"
                            variant="destructive"
                            className="text-xs md:text-sm px-2 md:px-3"
                            onClick={() => {
                              cambiarEstado(Number(deposito.idDepositoBanco))
                            }}
                            disabled={fechaNoSeleccionada}
                          >
                            <CircleMinus size={16} />
                          </Button>
                        </div>
                      ))
                    )
                  }
                  </div>
                  <div>
                    {
                    depositoBancoList.length === 0 ? (
                      <div className="py-2 text-start align-bottom">
                      </div>
                    ) : (
                      depositoBancoList.map((deposito) => (
                        <div key={deposito.idDepositoBanco} className="py-2 text-start align-bottom">
                          <div className="px-4 py-2 pr-7 bg-primary/10 border border-primary/0 rounded-lg text-end font-medium text-primary">
                            Q{(Number(deposito.cantidad)).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                          </div>
                        </div>
                      ))
                    )
                  }
                  </div>
                </div>
              <div className="pt-4 border-t-1 border-primary">
                <div className="flex justify-between items-center">
                  <span className="font-bold">Diferencia:</span>
                  <span className="font-bold text-primary px-8">
                    Q{Number(diferencia).toLocaleString('es-GT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </span>
                </div>
              </div>
              <div className="pt-4">
                <div className="flex justify-between items-center">
                  <span className="font-bold">Estado del Cierre:</span>
                  <div className="flex">
                    {getEstadoIcon(estado)}
                    <span className={`font-bold ${getEstadoColor(estado)} px-8`}>
                      {estado} 
                    </span>
                  </div>
                </div>
              </div>
              {sobregirado && (
                <div className = "pt-4 flex gap-4 justify-center items-center text-destructive">
                      <BadgeAlert/>
                      <span className={`font-bold px-8`}>
                        SOBREGIRADO
                      </span>
                </div>
              )}
              <div className = "flex gap-4 justify-center items-center">
                {efectivoDepositar && (
                    <span className="text-destructive text-center text-sm">{efectivoDepositar}</span>
                )}
              </div>
              <div className = "flex gap-4 justify-center items-center">
                {error && (
                    <span className="text-destructive text-center text-sm">{error}</span>
                )}
              </div>
              <div className="grid grid-cols-3 gap-4 items-end align-top">
                  <div className="py-2 text-start font-medium">
                    Comentario:
                  </div>
                  <div className='col-span-2'>
                    <Textarea
                      className="bg-white text-start"
                      value={comentario}
                      onChange={(e) => setComentario(e.target.value)}
                      disabled={fechaNoSeleccionada}
                    />
                  </div>
              </div>
              <div className={`grid grid-cols-3 gap-4 items-end align-top ${observacion.length > 0 ? '' : 'invisible'}`}>
                  <div className="py-2 text-start font-medium">
                    Observación:
                  </div>
                  <div className='col-span-2'>
                    <Textarea
                      className="bg-white text-start"
                      value={observacion}
                      disabled
                    />
                  </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                <Button variant="ghost" onClick={reiniciar} disabled={fechaNoSeleccionada}>
                  Cancelar
                </Button>
                <Button variant="accent" onClick={() => setMostrarConfirmar(true)} disabled={fechaNoSeleccionada}>
                  <Save className="w-4 h-4 mr-2" />
                  Guardar Cierre
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

<Confirmar
  visible={mostrarConfirmar}
  mensaje="¿Está seguro de que desea guardar este cierre?"
  isLoading={isSubmitting}
  onCancel={() => setMostrarConfirmar(false)}
  onConfirm={async () => {
    await handleSubmit();
    setMostrarConfirmar(false);
  }}
/>

      </div>
  );
}
